import React, { useRef } from "react";
import { Button } from "antd";
import { updatePriceListFile } from "../../http/priceListAPI";
import "./UploadPriceList.scss";

const UploadPriceList = ({ id, onSuccess }) => {

    let language;

    switch (Number(id)) {
        case 1:
            language = "Հայ";
            break;
        case 2:
            language = "Անգլ";
            break;
        case 3:
            language = "Ռուս";
            break;
        default:
            language = "Հայ";
    }

    const fileInputRef = useRef(null);

    const handleClick = () => {
        fileInputRef.current.click();
    };

    const handleFileChange = async (event) => {
        const file = event.target.files[0];
        if (file) {

            // Build FormData for multipart/form-data
            const formData = new FormData();
            formData.append("name", file.name); // or a custom name
            formData.append("file", file);

            try {
                const response = await updatePriceListFile(id, formData);
                if (onSuccess) onSuccess(response); // notify parent
            } catch (error) {
                console.error("Upload failed:", error);
            }
        }
    };

    return (
        <div className="upload-price-list">
            <Button
                onClick={handleClick}
                color={"cyan"}
                variant="outlined"
            >
                <span>+ գնացուցակ {language}</span>
            </Button>
            <input
                type="file"
                ref={fileInputRef}
                style={{ display: "none" }}
                accept=".csv,.xlsx,.xls,.pdf"
                onChange={handleFileChange}
            />
        </div>
    );
};

export default UploadPriceList;
